import { type Payment, columns } from "./columns";
import { DataTable } from "./data-table";

export default function Table() {
  const data: Payment[] = [
    {
      id: "728ed52f",
      amount: 100,
      status: "pending",
      email: "b@example.com",
    },
    {
      id: "728rd52f",
      amount: 100,
      status: "pending",
      email: "m@example.com",
    },
    {
      id: "418ed52f",
      amount: 100,
      status: "processing",
      email: "a@example.com",
    },
  ];

  return (
    <div className="container mx-auto py-10">
      <DataTable columns={columns} data={data} />
    </div>
  );
}
